import { Search } from 'ui/icons';
import { InputText, InputTextProps } from 'ui/inputs';
import { SegmentedControlNoSizeProps, SmallSegmentedControl } from 'ui/segmentedControl';
import {
  ALIGNMENT,
  BasicSelectWithNestedChildren,
  RawSelectProps,
  SelectOptionsContainer,
  SelectValueType,
  StickyWrapper,
} from 'ui/selects';
import noop from 'utils/noop';

type InsightSelectProps = {
  selectTestId?: RawSelectProps['data-test'];
  selectPlaceholder: RawSelectProps['placeholder'];
  selectOptions: RawSelectProps['options'];
  onOptionSelect: RawSelectProps<SelectValueType>['onSelect'];
  showSegmentedControl?: boolean;
  segmentedControlTestId?: string;
  segmentedControlMode?: string;
  segmentedControlOptions?: SegmentedControlNoSizeProps['options'];
  onSegmentedControlSelect?: SegmentedControlNoSizeProps['onSelect'];
  textInputPlaceholder: InputTextProps['placeholder'];
};

export const InsightSelect = ({
  isDisabled,
  selectTestId = '',
  selectPlaceholder,
  size,
  width,
  horizontalAlignment = ALIGNMENT.RIGHT,
  selectOptions,
  onOptionSelect,
  showSegmentedControl = false,
  segmentedControlTestId = '',
  segmentedControlMode = '',
  segmentedControlOptions = [],
  onSegmentedControlSelect = noop,
  textInputPlaceholder,
  Trigger,
  SelectWrapper,
  shouldFocusOnFirstElementByDefault = false,
}: InsightSelectProps & Omit<RawSelectProps<SelectValueType>, 'options'>) => {
  return (
    <BasicSelectWithNestedChildren
      data-test={selectTestId}
      isDisabled={isDisabled}
      onSelect={onOptionSelect}
      options={selectOptions}
      placeholder={selectPlaceholder}
      horizontalAlignment={horizontalAlignment}
      size={size}
      Trigger={Trigger}
      SelectWrapper={SelectWrapper}
      autoFocusOnInput
      shouldFocusOnFirstElementByDefault={shouldFocusOnFirstElementByDefault}
      width={width}
      SelectOptionsContainer={SelectOptionsContainer}
    >
      {showSegmentedControl ? (
        <>
          <StickyWrapper>
            <SmallSegmentedControl
              data-test={segmentedControlTestId}
              value={segmentedControlMode}
              options={segmentedControlOptions}
              onSelect={onSegmentedControlSelect}
              isFullWidth={true}
            />
          </StickyWrapper>
          <InputText
            type="search"
            autoComplete="off"
            id="behavioral-event-input-filter"
            placeholder={textInputPlaceholder}
            Prefix={<Search />}
            value=""
            autoFocus
          />
        </>
      ) : (
        <InputText
          type="search"
          autoComplete="off"
          id="conversion-event-input-filter"
          placeholder={textInputPlaceholder}
          Prefix={<Search />}
          value=""
          autoFocus
        />
      )}
    </BasicSelectWithNestedChildren>
  );
};
